import { render, staticRenderFns } from "./image-upload-field.vue?vue&type=template&id=95832954"
import script from "./image-upload-field.vue?vue&type=script&lang=js"
export * from "./image-upload-field.vue?vue&type=script&lang=js"
import style0 from "./image-upload-field.vue?vue&type=style&index=0&id=95832954&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('95832954')) {
      api.createRecord('95832954', component.options)
    } else {
      api.reload('95832954', component.options)
    }
    module.hot.accept("./image-upload-field.vue?vue&type=template&id=95832954", function () {
      api.rerender('95832954', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/components/image-upload-field.vue"
export default component.exports